export * from './other-documents.component';
export * from './other-documents.module';